/**
 * @doc module
 * @name handler/purchase-form
 *
 * @description
 * # MODULE_TITLE
 *
 * MODULE_DESCRIPTION.
 */

import {rerenderValidationNew} from "../utils/validation";
import {trans} from "../i18n/i18n";

const PAYMENT_BUTTONS_SELECTOR = ".js-paymentButton";
const MESSAGE_BOX_SELECTOR = ".PaymentOptions--messageBox";
const MESSAGE_BOX_TITLE_SELECTOR = ".PaymentOptions--messageBox-title";
const MESSAGE_BOX_MESSAGE_SELECTOR = ".PaymentOptions--messageBox-message";
const MESSAGE_BOX_FOOTER_SELECTOR = ".PaymentOptions--messageBox-footer";

const PAYMENT_SUCCESSFUL = 1;  // Payment::STATUS_OK
const PAYMENT_PENDING = 2;  // Payment::STATUS_PENDING
const PAYMENT_FAILED = 3;  // Payment::STATUS_DID_NOT_PROCESS

const CLASS_OK = "is-ok";
const CLASS_ERROR = "is-erroneous";

export default class PurchaseFormHandler {
  constructor($form) {
    this.$form = $form;
    this.$form.prepend(renderOverlay());
    this.cleanup();
  }

  /**
   *
   * @param {int} status Status code
   * @param {string} title Title of the message
   * @param {string} message The message itself
   * @param {string} footer Footer of the message
   * @param {object} redirect Information where to redirect user if applicable
   * @param {string} redirect_url URL where to redirect the user
   * @param {string} redirect_method Method to use for the redirect
   * @param {object} gatewayData
   */
  done({status, title, message, footer, redirect_url, redirect_method, gatewayData}) {
    this.cleanup();

    let formClass = "";
    switch (status) {
      case PAYMENT_SUCCESSFUL:
        formClass = CLASS_OK;
        break;
      case PAYMENT_FAILED:
        formClass = CLASS_ERROR;
        break;
    }

    this.$form.addClass(formClass);
    $(PAYMENT_BUTTONS_SELECTOR)
      .addClass("is-disabled")
      .attr("disabled", "disabled");
    renderResponse(formClass, message, title, footer);

    if (redirect_url) {
      if (formClass === CLASS_OK) sessionStorage.setItem('paymentInProgress', 'false');
      paymentRedirect(redirect_url, redirect_method);
    }
  }

  fail({responseJSON}) {
    this.cleanup();

    if (typeof responseJSON === "undefined") {
      responseJSON = {
        title: trans("We were unable to process your order."),
        message: trans("Failed to finish your purchase. Please contact customer support."),
      };
    }

    let message = responseJSON.hasOwnProperty("message") ? responseJSON["message"] : "";
    let title = responseJSON.hasOwnProperty("title") ? responseJSON["title"] : "";
    let footer = responseJSON.hasOwnProperty("footer") ? responseJSON["footer"] : "";

    renderResponse(CLASS_ERROR, message, title, footer);

    if (!responseJSON.hasOwnProperty("errors")) {
      this.$form.addClass(CLASS_ERROR);

      return;
    }

    $(PAYMENT_BUTTONS_SELECTOR)
      .removeClass("is-disabled")
      .removeAttr("disabled");

    const errors = responseJSON["errors"];
    for (let key in errors) {
      if (errors.hasOwnProperty(key)) {
        try {
          rerenderValidationNew(document.getElementById(`billingInfo-${key}`), [errors[key]]);
        } catch (e) { }
      }
    }
  }

  always() {
    this.removeOverlay();
  }

  cleanup() {
    this.$form
      .removeClass(CLASS_OK)
      .removeClass(CLASS_ERROR);

    let $messageBox = $(MESSAGE_BOX_SELECTOR);

    $messageBox
      .removeClass(`${CLASS_OK} ${CLASS_ERROR}`)
      .addClass("d-none");
    $messageBox.find(`${MESSAGE_BOX_TITLE_SELECTOR}, ${MESSAGE_BOX_MESSAGE_SELECTOR}, ${MESSAGE_BOX_FOOTER_SELECTOR}`)
      .addClass("d-none")
      .html("");
  }

  removeOverlay() {
    this.$form
      .find(".js-paymentOverlay")
      .remove();
  }
}

function paymentRedirect(url, method = "GET", data = {}) {
  if (method.toUpperCase() === "GET") {
    window.location = url;
    return;
  }

  const $form = $(`<form name="payment_redirect" action="${url}" method="${method}" class="d-none">`);

  for (const prop in data) {
    if (!data.hasOwnProperty(prop)) {
      continue;
    }

    $form.append(`<input type="hidden" name="${prop}" value="${data[prop]}">`);
  }

  $("body").append($form);
  $form.submit();
}

function renderOverlay() {
  return `
    <div class="u-overlay u-overlay--centerize js-paymentOverlay">
        <span class="Spinner Spinner--100px">
            <span class="Spinner-1"></span>
            <span class="Spinner-2"></span>
        </span>
    </div>
  `;
}

function renderResponse(mainClass, message, title = "", footer = "") {
  if (title) {
    $(`${MESSAGE_BOX_TITLE_SELECTOR}`)
      .removeClass("d-none")
      .html(title);
  }
  if (footer) {
    $(`${MESSAGE_BOX_FOOTER_SELECTOR}`)
      .removeClass("d-none")
      .html(footer);
  }
  if (message) {
    $(`${MESSAGE_BOX_MESSAGE_SELECTOR}`)
      .removeClass("d-none")
      .html(message);
  }

  $(MESSAGE_BOX_SELECTOR)
    .removeClass("d-none")
    .addClass(mainClass);

  // Scroll to the Message box (the same function is in _message-box.blade)
  let $form = $(MESSAGE_BOX_SELECTOR).closest("form");
  let scrollTo = ($form[0].scrollHeight > window.innerHeight) ?
    $form.offset().top + $form[0].scrollHeight - (window.innerHeight * .99) :
    $form.offset().top;
  $([document.documentElement, document.body]).animate({scrollTop: scrollTo}, 500);
}
